import React, { useCallback } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Row,
  Col,
  Spinner,
} from "@/Components/Common/Tailwind";

import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useInfiniteQuery } from "@tanstack/react-query";
import CouponGiftModal from "../../../../Components/modal/CouponGiftModal";
import { useUserStore } from "../../../../store/store";
import CouponInfoModal from "../../../../Components/modal/CouponInfoModal";
import { getAccessToken } from "../../../../api/auth";
import {
  couponService
} from "../../../../api/services/coupon.service";

const Item = styled.div`
  border-radius: 0.5vh;
  box-shadow: 1px 2px 6px 0px hsl(0deg 0% 64% / 22%);
  background-color: white;
  border: 1px solid #e5e7eb;
  /* max-width: 480px; */
  padding: 10px 20px;
  opacity: ${(props) => (props.visible ? "1" : "0.5")};
  :hover {
    cursor: ${(props) => (props.visible ? "pointer" : "default")};
  }
`;

const confirm = (message = null, onConfirm, onCancel) => {
  if (!onConfirm || typeof onConfirm !== "function") return;
  if (onCancel && typeof onCancel !== "function") return;
  const confirmAction = () => {
    if (window.confirm(message)) onConfirm();
    else onCancel();
  };
  return confirmAction;
};

function CouponSendGift() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [giftModal, setGiftModal] = React.useState(false);
  const [infoModal, setInfoModal] = React.useState(false);
  const [selectCoupon, setSelectCoupon] = React.useState({});
  const [permission, setPermission, user] = useUserStore((state) => [
    state.permission,
    state.setPermission,
    state.user,
  ]);

  const accessToken = getAccessToken();

  const fetchData = useCallback(
    async ({ pageParam = 1 }) => {
      const response = await couponService.getCouponGiftList(pageParam);

      const data = response.data;
      console.log("orderdata", data);
      return { ...data, results: data.results };
    },
    [accessToken]
  );

  const sendCancel = async (couponId) => {
    try {
      const response = await couponService.putCouponSendCancelById(couponId);

      return response.data;
    } catch (error) {
      console.log(error);
      // 오류 처리를 추가하거나 throw를 사용하여 상위 호출자에게 전달할 수 있습니다.
      throw error;
    }
  };

  const {
    status,
    data,
    error,
    isSuccess,
    isFetching,
    isFetchingNextPage,
    isFetchingPreviousPage,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["UserCouponList"],
    queryFn: async ({ pageParam = 1 }) => {
      // console.log("pageParam", pageParam);
      const data = await fetchData({ pageParam });
      // console.log("data", data);
      return data;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage && lastPage.next) {
        const match = lastPage.next.match(/page=(\d+)/);
        if (match) {
          return match[1];
        }
      }
      return undefined;
    },
  });

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12 flex flex-wrap justify-center gap-4">
          {isLoading ? (
            <div
              className="flex justify-center items-center"
              style={{ height: "50vh" }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : null}

          {data && isSuccess ? (
            <>
              {data?.pages.map((page, i) => (
                <React.Fragment key={i}>
                  {page.results.map((coupon, index) => (
                    <React.Fragment key={"coupon" + index}>
                      <Col
                        lg={12}
                        xxl={12}
                        md={12}
                        sm={12}
                        xs={12}
                        key={coupon.id}
                        className=""
                      >
                        <Item
                          visible={true}
                          className="w-md-480"
                          style={{
                            backgroundColor: "#fff",
                            opacity: coupon.state === "사용안함" ? 1 : 0.5,
                          }}
                        >
                          <div className="flex justify-between px-2 border-bottom items-center">
                            <div
                              className="card-title pt-3"
                              style={{ fontWeight: "600", maxWidth: "65%" }}
                            >
                              {coupon.coupon.title}
                            </div>
                            <p
                              className="font-bold mt-2"
                              style={{
                                opacity: coupon.state === "사용안함" ? 1 : 0.5,
                                color: "#f64757",
                              }}
                            >
                              {coupon.state}
                            </p>
                          </div>
                          <div className="flex justify-between px-2 border-bottom">
                            <div
                              className="card-title pt-3"
                              style={{ fontWeight: "600", color: "#f64757" }}
                            >
                              {coupon.coupon.discount_type === "price"
                                ? `${coupon.coupon.discount_amount.toLocaleString()}원 할인쿠폰`
                                : `${coupon.coupon.discount_rate}% 할인쿠폰`}
                            </div>
                          </div>
                          <div className="flex justify-between px-2 border-bottom">
                            <div className="card-text pt-3 pb-2" style={{}}>
                              만료기한 {coupon.coupon.expire_date}
                            </div>
                          </div>
                          {/* <div className="flex justify-between px-2 border-bottom">
                            <div className="card-title pt-3" style={{ fontWeight: "400", color: "#5d5d5d" }}>
                              {coupon.coupon.min_purchase.toLocaleString()}원 이상 구매시 사용가능
                            </div>
                          </div> */}

                          <div className="flex justify-between px-2">
                            <div
                              className="card-title pt-3"
                              style={{ fontWeight: "400", color: "#5d5d5d" }}
                            >
                              {coupon.gift_state === "수신함" &&
                                coupon.sender !== null &&
                                coupon.sender_phone_num === user.phone ? (
                                <>{coupon.phone_num}님께 선물하신 쿠폰입니다.</>
                              ) : null}
                            </div>
                          </div>

                          <div className="flex px-2">
                            <div className="mt-1" style={{ width: "100%" }}>
                              {coupon.sender !== null &&
                                coupon.sender_phone_num !== user.phone ? (
                                <p
                                  className="card-text py-2"
                                  style={{ float: "right" }}
                                >
                                  {coupon.sender_username}님께 선물받은
                                  쿠폰입니다.
                                </p>
                              ) : null}

                              {/* {coupon.coupon.bound_type === "reservation" ? (
                                <>
                                  <p className="card-text mb-1">예약가능기간</p>
                                  <p className="card-text pb-3">
                                    {coupon.coupon.use_start_date} ~ {coupon.coupon.use_end_date}
                                  </p>
                                </>
                              ) : null} */}
                              <Button
                                type="button"
                                variant="outline"
                                size="sm"
                                className="font-bold mt-2"
                                style={{
                                  opacity:
                                    coupon.state === "사용안함" ? 1 : 0.5,
                                  color: "#f64757",
                                  border: "1px solid #f64757",
                                }}
                                onClick={() => {
                                  setSelectCoupon(coupon);
                                  setInfoModal(true);
                                }}
                              >
                                상세보기
                              </Button>

                              {coupon.gift_state === "없음" ? (
                                <Button
                                  type="button"
                                  variant="primary"
                                  size="sm"
                                  className="font-bold mt-2"
                                  style={{
                                    opacity:
                                      coupon.state === "사용안함" ? 1 : 0.5,
                                    float: "right",
                                  }}
                                  onClick={() => {
                                    console.log("gift", coupon);
                                    setSelectCoupon(coupon);
                                    setGiftModal(true);
                                  }}
                                >
                                  선물하기
                                </Button>
                              ) : null}

                              {coupon.gift_state === "수신안함" &&
                                coupon.sender !== null &&
                                coupon.sender_phone_num === user.phone ? (
                                <Button
                                  type="button"
                                  variant="outline"
                                  size="sm"
                                  className="font-bold mt-2"
                                  style={{
                                    opacity:
                                      coupon.state === "사용안함" ? 1 : 0.5,
                                    float: "right",
                                    color: "#f64757",
                                  }}
                                  onClick={() => {
                                    confirm(
                                      `쿠폰선물을 취소하시겠습니까?`,
                                      () => {
                                        sendCancel(coupon.id)
                                          .then((data) => {
                                            if (data.status === "cancel ok") {
                                              toast.error("취소되었습니다.");
                                              refetch();
                                            } else {
                                              toast.error(
                                                "전송 실패 " +
                                                JSON.stringify(data)
                                              );
                                            }
                                          })
                                          .catch((e) => {
                                            console.log(e);
                                            toast.error("전송 실패");
                                          });
                                      },
                                      () => { }
                                    )();
                                  }}
                                >
                                  선물취소
                                </Button>
                              ) : null}

                              {coupon.gift_state === "수신함" &&
                                coupon.sender !== null &&
                                coupon.sender_phone_num === user.phone ? (
                                <span
                                  className="font-bold mt-2 inline-flex items-center justify-center rounded-[var(--btn-radius)] h-[var(--btn-h-sm)] px-[var(--btn-px-sm)] bg-[var(--btn-primary-bg)] text-[var(--btn-primary-fg)] border border-[var(--btn-primary-border)]"
                                  style={{ float: "right", opacity: 0.5 }}
                                >
                                  선물완료
                                </span>
                              ) : null}
                            </div>
                          </div>
                        </Item>
                      </Col>
                    </React.Fragment>
                  ))}

                  <CouponInfoModal
                    setVisible={setInfoModal}
                    visible={infoModal}
                    info={selectCoupon}
                    setInfo={setSelectCoupon}
                    navigate={navigate}
                    needRefresh={refetch}
                  />
                  <CouponGiftModal
                    setVisible={setGiftModal}
                    visible={giftModal}
                    info={selectCoupon}
                    setInfo={setSelectCoupon}
                    navigate={navigate}
                    needRefresh={refetch}
                  />
                </React.Fragment>
              ))}
            </>
          ) : null}

          {/* {!isLoading && data.pages.length === 0 ? (
            <div className="flex justify-center" style={{ alignItems: "center", height: 150 }}>
              다운받을 쿠폰이 없습니다.
            </div>
          ) : null}
           */}
          {hasNextPage ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="font-bold mt-2"
              style={{ color: "#f64757", border: "1px solid #f64757" }}
              onClick={() => {
                fetchNextPage();
              }}
            >
              다음
            </Button>
          ) : null}
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default CouponSendGift;
